import React, { useState, useEffect } from "react";
import { Field, FieldArray, getIn } from "formik";
import FileUploader from "react-firebase-file-uploader";
import { storage } from "../../util/firebase";
import useImage from "../../util/useImage";
import loading from "../../assets/loading.svg";
import { motion, AnimatePresence } from "framer-motion";
import { useData } from "../../util/dataProvider";
import Upload from "../../assets/logo.svg";

export default function Page1({
    values,
    page,
    setPage,
    setFieldValue,
    validateForm,
    errors,
    touched,
}) {
    const [logoUrl, setLogoUrl] = useState([]);
    const { submitError, assetUrl } = useData();
    const [number, setNumber] = useState(checkLength());
    function handleUpload(filename, index) {
        setFieldValue(`contact[${index}].image`, "images/" + filename);
        storage
            .ref("images")
            .child(filename)
            .getDownloadURL()
            .then((url) => {
                let array = [...logoUrl];
                array[index] = url;
                setLogoUrl(array);
            });
    }

    function checkLength() {
        let array = [1];
        if (values.contact.length > 0) {
            for (let i = 0; i < values.contact.length; i++) {
                array.push(1);
            }
        } else {
            return array;
        }
        array.pop();
        return array;
    }

    function getbild(length, i, array) {
        if (values.contact[i]?.image) {
            storage
                .ref(values.contact[i].image)
                .getDownloadURL()
                .then((url) => {
                    array[i] = url;
                    i = i + 1;
                    if (i < length) {
                        getbild(length, i, array);
                    } else {
                        setLogoUrl(array);
                    }
                });
        } else if (i < length) {
            i = i + 1;
            getbild(length, i, array);
        }
    }

    useEffect(() => {
        let array = [];
        let i = 0;
        if (values.contact.length > 0) {
            getbild(values.contact.length, i, array);
        }
    }, [values.contact]);

    function validate(value) {
        let error;
        if (!value) {
            error = "*Pflichtfeld";
        } else {
            error = null;
        }
        return error;
    }

    function isEmpty(obj) {
        return Object.keys(obj).length === 0;
    }

    return (
        <AnimatePresence>
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                style={{ marginBottom: "60px" }}>
                <FieldArray
                    name='contact'
                    render={(arrayHelpers) => (
                        <>
                            {number.map((item, index) => (
                                <>
                                    {index > 0 && <div className='line'></div>}
                                    <div
                                        className='page1-form'
                                        style={{
                                            marginTop: index > 0 ? "32px" : 0,
                                        }}>
                                        <div className='left-part'>
                                            <label
                                                htmlFor='contact-name'
                                                className='label'>
                                                Ansprechpartner*in Vorname,
                                                Nachname
                                            </label>
                                            <Field
                                                id={"contact-name" + index}
                                                name={`contact[${index}].name`}
                                                type='text'
                                                validate={validate}
                                            />
                                            {errors.contact &&
                                                touched.contact &&
                                                errors.contact[index] && (
                                                    <div className='errors'>
                                                        {
                                                            errors.contact[
                                                                index
                                                            ].name
                                                        }
                                                    </div>
                                                )}

                                            <label
                                                htmlFor='contact-website'
                                                className='label'>
                                                Position
                                            </label>
                                            <Field
                                                id={"contact-position" + index}
                                                name={`contact[${index}].position`}
                                                type='text'
                                            />
                                            <label
                                                htmlFor='contact-approved'
                                                className='label'>
                                                Telefon
                                            </label>
                                            <Field
                                                id={"contact-phone" + index}
                                                name={`contact[${index}].phone`}
                                                type='text'
                                            />
                                            <label
                                                htmlFor={
                                                    "contact-email" + index
                                                }
                                                className='label'>
                                                E-Mail Adresse
                                            </label>
                                            <Field
                                                id={"contact-email" + index}
                                                name={`contact[${index}].email`}
                                                type='text'
                                            />
                                        </div>
                                        <div className='left-part'>
                                            {index > 0 && (
                                                <div
                                                    className='delete'
                                                    onClick={() => {
                                                        arrayHelpers.remove(
                                                            index
                                                        );
                                                        let n = [...number];
                                                        n.pop();
                                                        setNumber(n);
                                                    }}>
                                                    Löschen
                                                </div>
                                            )}
                                            <label
                                                htmlFor='logo'
                                                className='label'>
                                                Profilbild
                                            </label>
                                            <div
                                                className='photoupload'
                                                style={{
                                                    backgroundImage: `url(${
                                                        assetUrl + Upload
                                                    })`,
                                                }}>
                                                <FileUploader
                                                    accept='image/*'
                                                    name='avatar'
                                                    randomizeFilename
                                                    beforeUploadStart={(
                                                        file
                                                    ) => {
                                                        if (
                                                            file.size >
                                                            2 * 1024 * 1024
                                                        ) {
                                                            alert(
                                                                "Bitte Bild unter 2MB hochladen!"
                                                            );
                                                            throw Error(
                                                                "too big"
                                                            );
                                                        } else if (
                                                            file.type !==
                                                                "image/jpeg" &&
                                                            file.type !==
                                                                "image/png" &&
                                                            file.type !=
                                                                "image/svg"
                                                        ) {
                                                            alert(
                                                                "Bitte verwenden Sie eines der folgenden Dateiformate: .jpg, .png, .svg"
                                                            );
                                                            throw Error(
                                                                "File type error"
                                                            );
                                                        }
                                                    }}
                                                    storageRef={storage.ref(
                                                        "images"
                                                    )}
                                                    onUploadStart={() => {
                                                        let array = [
                                                            ...logoUrl,
                                                        ];
                                                        array[index] =
                                                            assetUrl + loading;
                                                        setLogoUrl(array);
                                                    }}
                                                    onUploadSuccess={(
                                                        filename
                                                    ) =>
                                                        handleUpload(
                                                            filename,
                                                            index
                                                        )
                                                    }
                                                />
                                                {logoUrl[index] && (
                                                    <img
                                                        src={logoUrl[index]}
                                                        alt='Logo'
                                                        style={{
                                                            maxHeight: "90%",
                                                        }}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </>
                            ))}
                        </>
                    )}></FieldArray>
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                    onClick={() => {
                        let n = [...number];
                        n.push(1);
                        setNumber(n);
                    }}
                    className='button-green'>
                    Weiterer Ansprechpartner*innen
                </div>
                <label
                    className='small-text'
                    style={{ display: "flex", marginTop: "16px" }}>
                    <Field type='checkbox' name='datenschutz' />
                    Sie willigen hiermit ein, dass Ihre hier angegebenen Daten
                    auf der bergisch.metall Website veröffentlicht werden.
                </label>
                <div className='small-text' style={{ marginTop: "12px" }}>
                    Um sicher zu stellen, dass die teilnehmenden Unternehmen zu
                    unserem Verbund passen, wird Ihr Profil durch unser
                    bergisch.metall Team geprüft und erst danach veröffentlicht.
                    Sie erhalten eine Bestätigung, sobald Ihe Profil erfolgreich
                    erstellt wurde.
                </div>
                <div className='small-text' style={{ marginTop: "12px" }}>
                    Sollte es Probleme bei der Registrierung geben, dann
                    kontaktieren Sie uns bitte über folgende E-Mail-Adresse:{" "}
                    <a href='mailto:info@bergisch-metall.de'>
                        info@bergisch-metall.de
                    </a>
                </div>

                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                    }}>
                    <button
                        onClick={() => setPage(page - 1)}
                        className='button-red'>
                        Zurück
                    </button>
                    <div>
                        <button
                            className='button-red'
                            disabled={!values.datenschutz}
                            type='submit'>
                            Profil speichern
                        </button>
                        {submitError && (
                            <div
                                className='error'
                                style={{ marginTop: "12px", color: "#a72716" }}>
                                {submitError}
                            </div>
                        )}
                    </div>
                </div>
            </motion.div>
        </AnimatePresence>
    );
}
